export default {
      id: "arrow-both-usage",
      viewBox: "0 0 10 14",
      url: __webpack_public_path__ + "icons.svg#arrow-both",
      toString: function () {
        return this.url;
      }
    }